




















































































































import { mapActions, mapGetters } from 'vuex';

import mixins from '@/utils/mixins';
import QuoteStateMixin from '@/mixins/quoteState';
import auth from '@/mixins/auth';

import { IQuoteData, Quote, QuoteFieldError, QuoteState } from '@/models/quote';

import { ErrorManager } from '@/models/error';

import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteDocumentBuilderDialog from '@/components/quotes/QuoteDocumentBuilderDialog.vue';
import QuoteCreateSalesOpportunityListItem from '../QuoteCreateSalesOpportunityListItem.vue';

export default mixins(QuoteStateMixin, auth).extend({
  components: {
    ErrorAlert,
    QuoteDocumentBuilderDialog,
    QuoteCreateSalesOpportunityListItem
  },

  name: 'QuoteCustomerPreparationStateCard',

  computed: {
    ...mapGetters({
      getQuoteById: 'quote/getQuoteById'
    }),

    getColor(): string {
      return 'indigo lighten-1';
    },

    getIcon(): string {
      return 'mdi-send';
    },

    getString(): string {
      return 'Awaiting customer response';
    },

    getActionText(): string {
      return 'Accept';
    }
  },

  data: () => ({
    loading: false,

    fieldError: new QuoteFieldError()
  }),

  methods: {
    ...mapActions({
      setQuoteState: 'quote/setQuoteState',
      createQuoteRevision: 'quote/createQuoteRevision'
    }),

    clearErrors() {
      this.fieldError.clearErrors();
      this.clearAllErrors();
    },

    accepted() {
      this.setState(QuoteState.AWARDED);
    },

    rejected() {
      this.setState(QuoteState.LOST);
    },

    setState(state: QuoteState) {
      this.clearAllErrors();

      this.loading = true;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async createRevision(quoteData: IQuoteData) {
      this.clearAllErrors();
      this.loading = true;

      return this.createNewQuoteRevision(quoteData).catch(error => {
        if (error.response) {
          if (error.response.data.detail) {
            this.detailErrorMessage = error.response.data.detail;
          }
          if (QuoteFieldError.isQuoteFieldError(error.response.data)) {
            this.fieldError = new QuoteFieldError(error.response.data);
          }
        }
        this.errorMessage = ErrorManager.extractApiError(error);
        //because the page is reloaded there's no need to reset loading flag on finally
        this.loading = false;
      });
    }
  }
});
